import React from "react";
import { cn } from "@/utils/cn";

export interface BadgeProps extends React.ComponentPropsWithoutRef<"span"> {
  variant?: "count" | "dot";
  count?: number;
  max?: number;
}

const Badge = React.forwardRef<HTMLSpanElement, BadgeProps>(
  (
    { variant = "count", count = 0, max = 99, className = "", ...props },
    ref
  ) => {
    if (variant === "dot") {
      return (
        <span
          ref={ref}
          className={cn("block h-2 w-2 rounded-full bg-primary", className)}
          {...props}
        />
      );
    }

    return (
      <span
        ref={ref}
        className={cn(
          "inline-flex h-5 min-w-5 shrink-0 items-center justify-center rounded-full bg-primary px-1.5 text-[11px] font-bold text-white",
          className
        )}
        {...props}
      >
        {count > max ? `${max}+` : count}
      </span>
    );
  }
);
Badge.displayName = "Badge";

export default Badge;
